<div [class.photo-upload-disabled]="!photosAllowed()">
  @if (photos().length) {
    <ul
      class="checkup-photo-list list-reset mt-4 mb-4">
      @for (photo of photos(); track photo.id; let i = $index) {
        <li
          class="checkup-photo-holder iflex-center mb-0"
          [ngClass]="{pending: isUploadPendingPhoto(photo)}"
          [@fadeInOut]>
          @if (isInMemoryPhoto(photo)) {
            <img [src]="photo.data" [alt]="'uploaded-photo_' + photo.id">
          }
          @if (isUploadedPhoto(photo)) {
            <img [src]="photo.signedURL" [alt]="'uploaded-photo_' + photo.id">
          }
          @if (isFinalizedPhoto(photo)) {
            <img [src]="photo.url" [alt]="'uploaded-photo_' + photo.id">
          }
          @if (isUploadPendingPhoto(photo)) {
            <span class="pending-icon ox-icon ox-icon--file"></span>
          }
          @if (!readonly()) {
            <button
              type="button"
              class="ox-button ox-button--ghost ox-button--icon-small iflex-center"
              [disabled]="!photosAllowed() || isProcessing()"
              (click)="handleRemovePhoto(i)">
              <span class="ox-button__icon ox-icon ox-icon--close ox-icon--sm" aria-hidden="true"></span>
            </button>
          }
        </li>
      }
    </ul>
  }
  @if (isPhotoLimitReached) {
    <div class="photo-error ox-is-invalid mb-4" [@fadeInOut]>
      <p class="ox-form__feedback txt-cap flex-start">
        <span>{{ 'CHECKLIST.PHOTO_AMOUNT_LIMIT_ERROR' | translate:limit() }}</span>
        <span class="ox-icon ox-icon--error ml-2"></span>
      </p>
    </div>
  }
  @if (!readonly()) {
    <div class="ox-form__group">
      <zenith-form-group-label class="mb-1">{{ buttonTranslationKey | translate | titlecase }}</zenith-form-group-label>
      <button type="button"
        class="ox-button ox-button--secondary ox-button--icon"
        [attr.tabindex]="(photoType() === 'damage') ? '-1' : '0'"
        [ngClass]="'button-add-' + photoType() + '-photos'"
        [disabled]="!photosAllowed() || isPhotoLimitReached || formDisabled() || isProcessing()"
        [title]="buttonTranslationKey | translate | titlecase"
        (click)="capturePhoto(null)">
        <span class="ox-button__icon ox-icon ox-icon--upload" aria-hidden="true"></span>
      </button>
      <button type="button"
        class="ox-button ox-button--secondary ox-button--icon ml-1"
        [attr.tabindex]="(photoType() === 'damage') ? '-1' : '0'"
        [ngClass]="'button-add-' + photoType() + '-photos'"
        [disabled]="!photosAllowed() || isPhotoLimitReached || formDisabled() || isProcessing()"
        [title]="buttonTranslationKey | translate | titlecase"
        (click)="capturePhoto('environment')">
        <span class="ox-button__icon ox-icon ox-icon--camera" aria-hidden="true"></span>
      </button>
      <input type="file"
        accept="image/*"
        class="hidden"
        [attr.capture]="captureMode()"
        multiple
        #photoUpload
        [id]="photoType() + '-photo-upload'"
        (change)="handleInput($event)">
    </div>
  }
</div>
